import React, { Component } from 'react';
import { EUINumericField } from '../EUI/EUINumericField';

export class EUIPercentField extends Component {

    static defaultProps = {
        max: 100,
        min: 0,
        scale: 2,
        value: "",
    };
    
    render = () => {
        
        const { scale, value } = this.props;

        return <EUINumericField
            {...this.props}
            suffix="%"
            value={isNaN(value) ? "" : parseFloat(value).toFixed(scale)}
        />;

    };
}